import { render, staticRenderFns } from "./property-form.vue?vue&type=template&id=4a0c1793&scoped=true&"
import script from "./property-form.vue?vue&type=script&lang=js&"
export * from "./property-form.vue?vue&type=script&lang=js&"
import style0 from "./property-form.vue?vue&type=style&index=0&id=4a0c1793&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c1793",
  null
  
)

export default component.exports